var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4292 14.2995H2.4292V5.2995H5.0242C5.0242 5.2995 5.7132 4.4035 7.1942 3.2995H1.4292C1.16398 3.2995 0.909629 3.40486 0.722092 3.59239C0.534556 3.77993 0.429199 4.03428 0.429199 4.2995L0.429199 15.2995C0.429199 15.5647 0.534556 15.8191 0.722092 16.0066C0.909629 16.1941 1.16398 16.2995 1.4292 16.2995H16.4292C16.6944 16.2995 16.9488 16.1941 17.1363 16.0066C17.3238 15.8191 17.4292 15.5647 17.4292 15.2995V11.5535L15.4292 13.1985V14.2995ZM13.7902 7.3495V10.9005L20.4292 5.6995L13.7902 0.7005V3.8315C5.7292 3.8315 5.7292 11.7995 5.7292 11.7995C8.0112 8.0515 9.4152 7.3495 13.7902 7.3495Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.8be1bd392cc7835e8f53a161ade216cb.svg";
export { ForwardRef as ReactComponent };